const permanentRedirects = [
  { source: '/pro', destination: '/media-pro' },
  { source: '/almanac-page', destination: '/almanac' },
  { source: '/almanac-worldwide-page', destination: '/almanac' },
] as const

export default defineNuxtRouteMiddleware((route) => {
  const localeRoute = useLocaleRoute()

  const redirectPath = permanentRedirects
    .map(({ source, destination }) => ({
      source: localeRoute(source)?.path,
      to: localeRoute(destination)?.path,
    }))
    .find(({ source }) => source === route.path)?.to

  if (redirectPath) {
    return navigateTo(redirectPath, { redirectCode: 301 })
  }
})
